<script>
import Container from "@/components/atoms/container";
import Badge from "@/components/atoms/badge";
import Icon from "@/components/atoms/icon";
import List from "@/components/molecules/list/index";
import ListItem from "@/components/molecules/list/list-item";
import Captcha from "@/components/molecules/captcha";
import FormError from "@/components/molecules/form/form-error";
import Button from "@/components/atoms/button";
import ButtonGroup from "@/components/molecules/button-group";
import {
  formValidationProps,
  useFormValidation
} from "@/components/organisms/mixins/form-validation.mixin";

export default {
  name: "MdpOublieConfirmation",
  components: {
    Container,
    Badge,
    Icon,
    List,
    ListItem,
    Captcha,
    Button,
    ButtonGroup,
    FormError
  },
  props: {
    email: {
      type: String,
      required: true
    },
    ...formValidationProps()
  },
  emits: ["resetPassword"],
  setup(props) {
    const { captcha, v$ } = useFormValidation(props);
    return {
      captcha,
      v$
    };
  },
  data() {
    return {
      captchaToken: null
    };
  },
  methods: {
    verifyCaptcha(token) {
      if (token) {
        this.captchaToken = token;
      }
      const model = {
        email: this.email,
        captcha: this.captchaToken
      };
      this.$emit("resetPassword", model);
    },
    resetPassword() {
      this.$refs.captcha.execute();
    }
  }
};
</script>

<template>
  <Container>
    <div class="u-text-center">
      <Badge
        variant="success"
        circle
        size="xlg"
        class="u-mb-sm"
      >
        <Icon
          name="check"
          variant="white"
        />
      </Badge>
    </div>
    <h1 class="u-color-primary u-text-center u-font-24 u-font-700 u-mb-md">
      C’est envoyé !
    </h1>

    <p class="u-mr-lg u-ml-lg u-mb-xs u-font-15">
      Un lien vous permettant de réinitialiser votre mot de passe
      vient d'être envoyé par mail à l'adresse :
    </p>
    <p class="u-mr-lg u-ml-lg u-font-500 u-mb-lg">
      {{ email }}
    </p>
    <p class="u-mr-lg u-ml-lg  u-font-700  u-font-14 u-mb-xxs">
      Si vous ne recevez pas cet email dans les minutes qui suivent
    </p>
    <div class="u-mr-lg u-ml-lg u-mb-md">
      <List
        tag="ol"
        class="u-font-14"
      >
        <ListItem>
          1. Veillez à bien vérifier votre dossier « Spam » ou « Courrier indésirable » de votre messagerie
        </ListItem>
        <ListItem>
          2. Cliquez ci-dessous pour renvoyer l'email
        </ListItem>
      </List>
    </div>
    <Captcha
      ref="captcha"
      @verify="verifyCaptcha"
    />
    <ButtonGroup class="u-flex-column u-mt-md">
      <Button
        variant="secondary"
        radius="full"
        size="md"
        @click="resetPassword()"
      >
        Me renvoyer l'email
      </Button>
    </ButtonGroup>
    <FormError
      v-if="error"
      :error="error"
    />
  </Container>
</template>
